import ICategory from '../../interfaces/ICategory';

export interface CategoryWithParent extends ICategory {
  parent?: CategoryWithParent;
}

export class CategoryHelper {
  private _flatCatgories: CategoryWithParent[];

  constructor(tree: ICategory) {
    const categoryWithParent = this.getCategoryWithParent(tree);
    this._flatCatgories = this.getFlatCategories(categoryWithParent);
  }

  getCategoryWithParent(category: ICategory, parent?: CategoryWithParent): CategoryWithParent {
    const self = this;
    const categoryWithParent: CategoryWithParent = {
      ...category,
      parent,
    };

    if (!category.children || category.children.length === 0) {
      return categoryWithParent;
    }

    categoryWithParent.children = category.children.map((childCategory) =>
      self.getCategoryWithParent(childCategory, categoryWithParent)
    );

    return categoryWithParent;
  }

  getFlatCategories(category: CategoryWithParent): CategoryWithParent[] {
    const self = this;
    const categories: CategoryWithParent[] = [category];

    if (category.children && category.children.length > 0) {
      category.children.forEach((child) => {
        categories.push(...self.getFlatCategories(child));
      });
    }

    return categories;
  }

  findCategory(categoryTagId: string) {
    return this._flatCatgories.find((category) => category.categoryTagId === categoryTagId);
  }

  getAncestorCategories(category: CategoryWithParent) {
    const getAncestors = (cat: CategoryWithParent) => {
      const ancestors: CategoryWithParent[] = [];
      if (!cat.parent) {
        return ancestors;
      }

      ancestors.push(cat.parent);
      const parentAncestors = getAncestors(cat.parent);
      ancestors.unshift(...parentAncestors);

      return ancestors;
    };

    const ancestorCategories = getAncestors(category);

    return ancestorCategories;
  }
}
